/* global bocAmchart, gaVars, gtagEvent */

/**
 * @typedef {{bocSettings: {series, addExport, lookup}, listeners, export}} AMConfig
 */

/**
 * Add the event to call handle render
 *
 * @param {AMConfig} chartSettings The chart options
 * @returns {AMConfig} The modified chart options
 */

bocAmchart.addGoogleAnalyticsViewListener = function(chartSettings) {
    chartSettings.listeners.push({
        "event": "rendered",
        "method": bocAmchart.handleRender
    });
};

/**
 * Sends a GA view event
 * @param {object} event     The AMChart render event
 * @returns {void}
 */
bocAmchart.handleRender = function(event) {
    if ((typeof gaVars === 'object')) {
        var slug = gaVars.baseUrl;
        if (gaVars.baseUrl !== gaVars.pageUrl) {
            slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
        }

        var chartTitle = '';
        if (event.chart.titles.length > 0) {
            chartTitle = event['chart']['titles'][0]['text'];
        } else {
            chartTitle = 'no title';
        }
        var eventAction = chartTitle + ' View';
        var eventCategory = 'AmCharts';
        gtagEvent(eventCategory, eventAction, slug);
    }
};
